var _circle, _path, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSubject(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#80DDC6",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3913 6.91298H12.223C11.8853 6.91279 11.5479 6.93633 11.2135 6.98342C10.5599 7.06226 9.92397 7.24869 9.3313 7.53515C9.16607 7.61539 9.00656 7.70691 8.85391 7.80907C8.88659 7.74177 8.92318 7.67644 8.96348 7.61342L8.99478 7.55472C9.44084 6.88655 10.1205 6.40924 10.9004 6.21646C11.1401 6.15906 11.3857 6.13016 11.6322 6.13037H12.3913V6.91298ZM3.78261 6.13037H4.54174C5.37232 6.13502 6.16833 6.46353 6.76043 7.04602L6.85043 7.14385C7.03474 7.34461 7.19254 7.56818 7.32 7.80907C7.16997 7.70822 7.01306 7.618 6.85043 7.53907C6.46637 7.35022 6.06202 7.20581 5.64522 7.10863C5.17929 7.00424 4.70548 6.9388 4.2287 6.91298C4.13478 6.91298 4.04478 6.91298 3.95087 6.91298H3.78261V6.13037ZM3 7.69559H3.95087C4.83999 7.68092 5.72027 7.87386 6.52174 8.25907C6.68965 8.34183 6.84948 8.44008 6.99913 8.55255C7.33477 8.76308 7.58234 9.08854 7.69565 9.4682C7.70056 9.5294 7.70056 9.5909 7.69565 9.65211V11.9999H3V7.69559ZM13.1739 11.9999H8.47826V9.65211C8.47876 9.58514 8.4853 9.51834 8.49783 9.45255C8.62022 9.04317 8.89276 8.69515 9.26087 8.4782C9.88486 8.08445 10.5899 7.83696 11.323 7.75428H11.4052L11.7222 7.72298H11.8591C11.9791 7.72298 12.1004 7.72298 12.223 7.72298H13.1739V11.9999Z",
    fill: "#00BB8D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.0867,
    cy: 4.56522,
    r: 1.56522,
    fill: "#00BB8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSubject);
export default __webpack_public_path__ + "static/media/icon-subject.05fbe1bf89f55f1f1cd3371bd83566e6.svg";
export { ForwardRef as ReactComponent };